/*=========================================================================================
  File Name: moduleActivityActions.js
  Description: Activity Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Felix Masa
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	fetchIssuesListItems({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/manual_data")
				.then((response) => {
					commit("SET_ISSUES", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchIssuesListItemsByIdUploadedFile({commit}, uploadedFileId) {
		return new Promise((resolve, reject) => {
			Api.get(`/manual_data/${uploadedFileId}`)
				.then((response) => {
					commit("SET_ISSUES", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchActivityById({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.get(`/activity/${itemId}`)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeManualdataItem({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/manual_data/${itemId}`)
				.then((response) => {
					commit("REMOVE_MANUAL_DATA_ITEM", itemId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchFormsActivityList({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/forms/list")
				.then((response) => {
					commit("SET_FORMS_ACTIVITIES", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchManualDataFilter({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				page: data.page || 1,
				quantity: data.quantity || 1000000,
				id: data.id || [],
				fields: data.fields || [
					"id",
					"register",
					"validator",
					"upload_file_id",
					"company_id",
					"added_on",
					"update_on",
					"upload_file_name",
					"company_name",
				],
				upload_file_id: data.upload_file_id || [],
				upload_file_name: data.upload_file_name || [],
				order_by: data.order_by || ["upload_file_name"],
				sort: data.sort || "desc",
			};
			Api.post("/manual_data/filter", payload)
				.then((res) => {
					commit("SET_ISSUES", res.data.records);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
